import * as ACTION_TYPES from "../types";

let initialState = {
  forms: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_FORM_BY_ID:
      return {
        ...state,
        forms: action.data,
      };
    case ACTION_TYPES.CREATE_FORMS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ACTION_TYPES.CREATE_FORMS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ACTION_TYPES.CREATE_FORMS_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case ACTION_TYPES.GET_FORMS_BY_USER_ID:
      return {
        ...state,
        forms: action.data
      }
    default:
      return state;
  }
};
